export default "__VITE_ASSET__DcD1Kl7W__"